// styles/theme.js
const theme = {
    backgroundImage: "url('/images/background.png')",
    backgroundSize: "fill",
    backgroundPosition: "center",
    // backgroundColor: '#333131',
    textColor: '#E0E0E0',
    sidebarBackground: '#1E1E1E',
    sidebarTextColor: '#A0A0A0',
  };
  
  export default theme;
  